import type { PieValueType } from '@mui/x-charts';

export const getLabel = (label: PieValueType['label']) => {
  if (!label) return '';

  return typeof label === 'string' ? label : label('arc');
};
